import * as z from "zod/v4";

export const discardOptimizationDraft = {
  name: "discardOptimizationDraft" as const,
  input: z.object({ draftId: z.bigint() }),
  output: z.void(),
};
